export class AddLikeDto {
    add: boolean;
}
